import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonComponent } from '@atoms/button/button.component';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { SvgIcon } from '@services/svg-icon.service';

export interface NetworkOfflineBottomSheetData {
  title?: string;
  message?: string;
  retryLabel?: string;
}

@Component({
  selector: 'app-network-offline-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, SvgIconComponent],
  templateUrl: './network-offline-modal.component.html',
})
export class NetworkOfflineModalComponent {
  protected readonly SvgIcon = SvgIcon;

  private readonly bottomSheetRef = inject(MatBottomSheetRef<NetworkOfflineModalComponent>);
  protected readonly data = inject<NetworkOfflineBottomSheetData>(MAT_BOTTOM_SHEET_DATA, { optional: true }) ?? {};

  get title(): string {
    return this.data.title?.trim() || 'Sin conexión';
  }

  get message(): string {
    return this.data.message?.trim() || 'No pudimos conectarnos. Revisa tu internet e inténtalo nuevamente.';
  }

  get retryLabel(): string {
    return this.data.retryLabel?.trim() || 'Reintentar';
  }

  onClose(): void {
    this.bottomSheetRef.dismiss('close');
  }

  onRetry(): void {
    this.bottomSheetRef.dismiss('retry');
  }
}

